'use client';

import BDButton from '@shared/components/elements/button';
import { JewelryTypeMap } from '@shared/lib/constants';
import { searchJewelryProducts } from '@shared/lib/search/actions';
import { PageInfo } from '@shared/lib/shopify/types';
import { ShortJewelryProduct } from '@shared/lib/shopify/types/shopify-native';
import { capitalize, safeFirst } from '@shared/lib/utils';
import { useActionState, useState } from 'react';
import JewelryListItem from './jewelry-list-item';

const JewelryListManualLoad = ({
  pageInfo,
  ringFilters,
  cutFilters,
  metalFilters,
  productType,
}: {
  pageInfo: PageInfo;
  ringFilters: string[];
  cutFilters: string[];
  metalFilters: string[];
  productType: string;
}) => {
  const [products, setProducts] = useState<ShortJewelryProduct[]>([]);
  const [nextPageInfo, setNextPageInfo] = useState<PageInfo | null>(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     async (entries) => {
  //       if (
  //         entries[0]?.isIntersecting &&
  //         pageInfo.hasNextPage &&
  //         !hasLoaded &&
  //         !hasFetched.current
  //       ) {
  //         hasFetched.current = true;
  //         const { products, pageInfo: newPageInfo } = await searchJewelryProducts({
  //           ringFilters,
  //           cutFilters,
  //           metalFilters,
  //           sortKey: 'PRICE',
  //           reverse: false,
  //           first: 50,
  //           after: pageInfo.endCursor,
  //           productType: JewelryTypeMap[productType as keyof typeof JewelryTypeMap]
  //         });
  //         setProducts(products);
  //         setNextPageInfo(newPageInfo);
  //         setHasLoaded(true);
  //       }
  //     },
  //     { threshold: 0.1 }
  //   );

  //   if (loaderRef.current) {
  //     observer.observe(loaderRef.current);
  //   }

  //   return () => {
  //     if (loaderRef.current) {
  //       observer.unobserve(loaderRef.current);
  //     }
  //   };
  // }, []);
  const [error, formAction, isPending] = useActionState(async () => {
    const { products, pageInfo: newPageInfo } = await searchJewelryProducts({
      ringFilters,
      cutFilters,
      metalFilters,
      sortKey: 'PRICE',
      reverse: false,
      first: 36,
      after: pageInfo.endCursor,
      productType: JewelryTypeMap[productType as keyof typeof JewelryTypeMap],
    });
    setProducts(products);
    setNextPageInfo(newPageInfo);
    setHasLoaded(true);
    return null;
  }, null);
  return (
    <>
      {!hasLoaded && (
        <form className="col-span-full mt-8 flex justify-center" action={formAction}>
          <BDButton
            styleType="secondary"
            className="mx-4 w-full py-2 sm:mx-auto sm:w-1/3 md:w-1/4"
            type="submit"
            disabled={isPending}
          >
            Load More
          </BDButton>
          {error && <p className="text-red-500">{error}</p>}
        </form>
      )}
      {products.map((product) => (
        <JewelryListItem
          key={product.id}
          product={product}
          metal={safeFirst(metalFilters)}
          cutFilters={cutFilters.map(capitalize) as string[]}
        />
      ))}
      {nextPageInfo?.hasNextPage && (
        <JewelryListManualLoad
          pageInfo={nextPageInfo}
          ringFilters={ringFilters}
          cutFilters={cutFilters}
          metalFilters={metalFilters}
          productType={productType}
        />
      )}
    </>
  );
};

export default JewelryListManualLoad;
